/**
 * 2022-08-24: Strange error? Check the dynamic update code below / mh
 */
import React, { useState, useEffect } from "react";
import Radio from "./Radio";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import ValidationBar from "../common3/ValidationBar";
import filterString from "../common3/filterString";
import HelpIcon from "../common3/HelpBox/Icon";
import HelpBox from "../common3/HelpBox";
import { LabelWrapper, GroupLabel } from "./styled";
import SkeletonLoader from "../Common/Loaders/SkeletonLoader";
import didMount from "../common3/hooks/useDidMount";
import HorizontalRadioButtonGroup from "./HorizontalRadioButtonGroup";

const Radio3 = (props) => {
  const {
    extra = {},
    value = null,
    save = () => {},
    id,
    effects,
    runEffect,
    formData,
    validationError = {},
    disableValidation,
    dispatchEvent,
    htmlTemplates = {},
  } = props;
  let {
    name = "radio" + id,
    label = "test",
    subLabel = "",
    options = [
      { label: "test", value: "test" },
      { label: "test2", value: "test2" },
    ],
    optionsType = "static",
    effects: extraEffects = null,
    helpBoxAlwaysVisible = false,
    helpBoxIcon = false,
    helpBoxTemplateId = null,
    helpBoxTemplate = null,
    validation = {},
    appearance = "standard",
  } = extra;
  const disabled = props.disabled || extra.disabled;
  const { required = false } = validation;
  const [selectedValue, setSelectedValue] = useState(value);
  const [helpBoxOpen, setHelpBoxOpen] = useState(
    helpBoxAlwaysVisible ? true : false
  );

  let optionsToDisplay = null;

  let error = validationError.critical ? "critical" : null;
  let errorMessage = validationError.critical;
  if (!error) {
    error = validationError.error ? "danger" : null;
    errorMessage = validationError.error;
  }
  if (!error) {
    error = validationError.warning ? "warning" : null;
    errorMessage = validationError.warning;
  }

  /**
   * MOUNT: Check for default values
   *
   * Handle static-values first, then check for defaults
   */
  useEffect(() => {
    if (
      value === null &&
      (optionsType === "static" || optionsType === "advanced")
    ) {
      let newValue = null;
      options?.forEach((o) => {
        if (o.setDefault) {
          newValue = o.value ? o.value : o.label;
        }
      });
      setSelectedValue(newValue);
    }
  }, []);

  useEffect(() => {
    if (didMount) {
      if (value === null) {
        let defaultValue = value;

        if (extra.defaultStatic === true) {
          defaultValue = filterString(extra.staticValue, props, {});
        }

        if (!defaultValue && Array.isArray(options)) {
          options?.forEach((o) => {
            if (o.setDefault) {
              defaultValue = o.value ? o.value : o.label;
            }
          });
        }

        setSelectedValue(defaultValue);
      } else {
        setSelectedValue(value);
      }
    }
  }, [value]);

  useEffect(() => {
    if (
      (optionsType === "effects" || optionsType === "register") &&
      !isEmpty(extraEffects)
    ) {
      runEffect({ source: extraEffects, effectId: id });
    }
  }, [id, formData, optionsType, runEffect, extraEffects]);

  useEffect(() => {
    if (didMount && selectedValue && selectedValue !== value) {
      save({ key: props.id, value: selectedValue });
      dispatchEvent("onChange");
    }
  }, [selectedValue]);

  if (typeof optionsToDisplay === "string") {
    return <div>FEL</div>;
  }

  if (
    (optionsType === "effects" || optionsType === "register") &&
    !isEmpty(extraEffects)
  ) {
    optionsToDisplay = get(effects, [id], null);
  } else {
    optionsToDisplay = options;
  }

  const _helpBoxTemplate =
    helpBoxTemplateId === "_custom"
      ? helpBoxTemplate
      : get(htmlTemplates, [helpBoxTemplateId, "html"], "");

  if (!optionsToDisplay) {
    return <SkeletonLoader height={40} count={2} />;
  }

  return (
    <>
      <fieldset className={required ? "sp-required" : ""}>
        <LabelWrapper aria-label={label || "Radiobutton"}>
          {extra.label && <GroupLabel>{label}</GroupLabel>}
          {!helpBoxAlwaysVisible && helpBoxIcon && (
            <HelpIcon toggle={() => setHelpBoxOpen(!helpBoxOpen)} />
          )}
        </LabelWrapper>

        {appearance !== "standard" ? (
          <HorizontalRadioButtonGroup
            options={optionsToDisplay}
            selectedValue={selectedValue}
            setSelectedValue={setSelectedValue}
            appearance={appearance}
            disabled={disabled}
          />
        ) : (
          optionsToDisplay &&
          optionsToDisplay.map((line, i) => {
            let { label, value } = line;

            if (typeof line === "string") {
              label = line;
              value = line;
            }

            return (
              <Radio
                key={i}
                id={`${props.id}_${i}`}
                name={name}
                label={label}
                value={value ? value : label}
                checkedValue={selectedValue}
                setCheckedValue={setSelectedValue}
                disabled={disabled}
                error={error}
              />
            );
          })
        )}
        {(helpBoxAlwaysVisible || helpBoxIcon) &&
          _helpBoxTemplate &&
          helpBoxOpen && (
            <HelpBox template={_helpBoxTemplate} props={props} value={value} />
          )}
        <ValidationBar
          error={errorMessage}
          subLabel={subLabel}
          disableValidation={disableValidation}
        />
      </fieldset>
    </>
  );
};

export default Radio3;
